import { render, staticRenderFns } from "./ProformaExchangeRateGrid.vue?vue&type=template&id=4dade8b7&scoped=true"
import script from "./ProformaExchangeRateGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProformaExchangeRateGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProformaExchangeRateGrid.vue?vue&type=style&index=0&id=4dade8b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dade8b7",
  null
  
)

export default component.exports